function redirectToCart (queryStringParams) {

	window.setTimeout(() => {

		window.parent.location.href = `/cart/${queryStringParams ? `?${queryStringParams}` : ''}`;

	}, 0);

}

export default redirectToCart;
